import { DialogComponent } from '@theme/dialog';

/**
 * A custom element that manages a filter drawer for any filter type.
 *
 * @extends {DialogComponent}
 */
class FilterDrawer extends DialogComponent { 
  connectedCallback() {
    super.connectedCallback();
    
    // Prevent form from auto-submitting
    const form = this.querySelector('.filter-drawer__form');
    if (form) {
      form.addEventListener('submit', this.#handleFormSubmit);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    
    const form = this.querySelector('.filter-drawer__form');
    if (form) {
      form.removeEventListener('submit', this.#handleFormSubmit);
    }
  }

  #handleFormSubmit = (event) => {
    // Let the form submit naturally (only happens when Apply Filters is clicked)
    // Don't prevent default - we want the form to submit normally
  };

  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('filter-drawer')) {
  customElements.define('filter-drawer', FilterDrawer);
}

